import { Box, Typography } from '@mui/material'
import { createElement } from 'react'
import { ElementFactory, Serializer, Question } from 'survey-core'
import { ReactQuestionFactory, SurveyQuestionElementBase } from 'survey-react-ui'
import { styles } from './SurveyHeader.styles'

const CUSTOM_TYPE = 'surveyheader'

export class SurveyHeader extends Question {
  constructor (name: string) {
    super(name)
    this.titleLocation = 'hidden'
  }

  getType (): string {
    return CUSTOM_TYPE
  }

  get text (): string {
    return this.getPropertyValue('text')
  }

  set text (val: string) {
    this.setPropertyValue('text', val)
  }

  get variant (): 'h4' | 'h5' | 'h6' {
    return this.getPropertyValue('variant') ?? 'h5'
  }

  set variant (val: 'h4' | 'h5' | 'h6') {
    this.setPropertyValue('variant', val)
  }
}

export function registerHeaderQuestion (): void {
  ElementFactory.Instance.registerElement(
    CUSTOM_TYPE,
    (name) => {
      return new SurveyHeader(name)
    }
  )

  Serializer.addClass(
    CUSTOM_TYPE,
    [
      {
        name: 'text',
        type: 'text',
        category: 'general'
      },
      {
        name: 'variant',
        type: 'text',
        category: 'general',
        default: 'h5'
      }
    ],
    function () {
      return new SurveyHeader('')
    },
    'question'
  )

  ReactQuestionFactory.Instance.registerQuestion(CUSTOM_TYPE, (props) => {
    return createElement(SurveyQuestionHeader, props)
  })
}

export class SurveyQuestionHeader extends SurveyQuestionElementBase {
  get question (): SurveyHeader {
    return this.questionBase as SurveyHeader
  }

  renderElement (): JSX.Element {
    return (
      <Box sx={styles.container}>
        <Typography variant={this.question.variant} >
          {this.question.text}
        </Typography>
        {this.question.description != null && this.question.description !== '' && (
          <Typography sx={styles.description}>
            {this.question.description}
          </Typography>
        )}
      </Box>
    )
  }
}
